// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".basic-table-action-icons {\n  margin-right: 10px !important;\n  cursor: pointer;\n}\n", "",{"version":3,"sources":["webpack://./src/assets/styles/lkqAdminUI.less"],"names":[],"mappings":"AAAA;EACE,6BAAA;EACA,eAAA;AACF","sourcesContent":[".basic-table-action-icons {\n  margin-right: 10px !important;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
